import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import CustomModal from "../../../Shared/CustomModal";
import { Button } from "@mui/material";
import { useMutation } from "react-query";
import { postImagesFn } from "../../../Services/Images";
import { toast } from "react-toastify";

const AddImages = ({ refetch }) => {
  const [preview, setPreview] = useState(null);
  const [open, setOpen] = useState(false);

  const validationSchema = Yup.object({
    name: Yup.string().required("Name is required"),
    image: Yup.mixed().required("Image is required"),
  });

  const { mutate: AddImages } = useMutation(postImagesFn, {
    onSuccess: (res) => {
      if (res?.data?.response_code === 200) {
        refetch();
        toast.success(res?.data?.message);
        setPreview(null);
        setOpen(false);
      } else {
        toast.success(res?.data?.message);
      }
    },
  });

  const initialValues = {
    name: "",
    image: null,
  };

  const handleSubmit = (values) => {
    const formData = new FormData();
    formData.append("title", values.name);
    formData.append("image", values.image);

    AddImages(formData);
  };

  return (
    <>
      <Button onClick={() => setOpen(true)} variant="outlined">
        Add
      </Button>

      <CustomModal open={open} setOpen={setOpen}>
        <div className="bg-white p-6 rounded-lg shadow-md w-full ">
          <h2 className="text-xl font-semibold text-center mb-4">
            Add Image 
          </h2>

          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ setFieldValue }) => (
              <Form className="space-y-4">
                {/* ✅ Name Field */}
                <div>
                  <label className="block mb-1 font-medium">Name</label>
                  <Field
                    type="text"
                    name="name"
                    placeholder="Enter name"
                    className="w-full border px-3 py-2 rounded"
                  />
                  <ErrorMessage
                    name="name"
                    component="p"
                    className="text-red-500 text-sm"
                  />
                </div>

                {/* ✅ Image Upload */}
                <div>
                  <label className="block mb-1 font-medium">Image</label>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={(event) => {
                      const file = event.target.files[0];
                      setFieldValue("image", file);
                      setPreview(URL.createObjectURL(file));
                    }}
                    className="w-full border px-3 py-2 rounded"
                  />
                  <ErrorMessage
                    name="image"
                    component="p"
                    className="text-red-500 text-sm"
                  />
                </div>

                {/* ✅ Image Preview */}
                {preview && (
                  <div className="flex justify-center">
                    <img
                      src={preview}
                      alt="Preview"
                      className="w-32 h-32 object-cover rounded border"
                    />
                  </div>
                )}

                {/* ✅ Submit Button */}
                <button
                  type="submit"
                  className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700 transition"
                >
                  Submit
                </button>
              </Form>
            )}
          </Formik>
        </div>
      </CustomModal>
    </>
  );
};

export default AddImages;
